import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=13b9d622&scoped=true&"
import script from "./branding.vue?vue&type=script&lang=js&"
export * from "./branding.vue?vue&type=script&lang=js&"
import style0 from "./branding.vue?vue&type=style&index=0&id=13b9d622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9d622",
  null
  
)

component.options.__file = "branding.vue"
export default component.exports